import React from 'react';
import { ProjectGrowthAlertCard } from '../components/ProjectGrowthAlertCard/ProjectGrowthAlertCard.esm.js';

class ProjectGrowthAlert {
  data;
  constructor(data) {
    this.data = data;
  }
  get url() {
    return "/cost-insights/investigating-growth";
  }
  get title() {
    return `Investigate cost growth in project ${this.data.project}`;
  }
  get subtitle() {
    return "Cost growth outpacing business growth is unsustainable long-term.";
  }
  get element() {
    return /* @__PURE__ */ React.createElement(ProjectGrowthAlertCard, { alert: this.data });
  }
}

export { ProjectGrowthAlert };
//# sourceMappingURL=ProjectGrowthAlert.esm.js.map
